<div class="site-header">
    <app-header-topbar></app-header-topbar>

    <div *ngIf="layout === 'classic'" class="site-header__middle container" id="header">
        <div class="site-header__logo">
            <a routerLink="/" class="site-header__brand">
                <app-brand-logo></app-brand-logo>
            </a>
        </div>
        <div class="site-header__search">
            <app-search location="header"></app-search>
        </div>
        <div class="site-header__phone">
            <!-- <div class="site-header__phone-title">Customer Service</div> -->
             <a class="btn btn-xs btn-secondary cnt-btn" routerLink="/contact">
                <app-icon style="fill: #f0f0f0;" name="support-call-green" size="16"></app-icon>
                <span>{{ 'customer-support' | t:'Customer Support' }}</span>
             </a>
        </div>
    </div>

    <div class="site-header__nav-panel">
        <app-header-nav
            [departments]="layout === 'classic'"
            [logo]="layout === 'compact' || staff"
            [search]="layout === 'compact'"
            stickyMode="pullToShow"
        ></app-header-nav>
    </div>
</div>
